import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=1451d542&"
import script from "./ClientTable.vue?vue&type=script&lang=js&"
export * from "./ClientTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports